<template>
  <section id="section1" class="section" style="position: relative">
  <div class="offer-and-privacy-policy mt-app-header " style="">
    <OfferAndPrivacyPolicyScreen></OfferAndPrivacyPolicyScreen>
  </div>
  </section>
  <section id="section2" class="section" style="position: relative"> <div class="client-footer" >
    <ClientFooter></ClientFooter>
  </div>
  </section>
</template>

<style scoped lang="scss">
@media (max-width: 600px) {
  .mt-app-header{
    margin: 15% 2% 2% !important;
  }
}
@media (max-width: 1100px) and (min-width: 601px){
  .mt-app-header{
    margin: 8% 2% 2% !important;
  }
}
@media (min-width: 1101px) {
  .mt-app-header{
    margin: 5% 2% 2% !important;
  }
}
</style>
<script>

import OfferAndPrivacyPolicyScreen from "@/components/additionalInformation/OfferAndPrivacyPolicyScreen.vue"
import ClientFooter from "@/components/footers/ClientFooter.vue";
export default {
  name: 'OfferAndPrivacyPolicyView',
  components: {
    OfferAndPrivacyPolicyScreen,
    ClientFooter
  }
}
</script>
